import { gql } from '@provision/graphql-client';

export const GET_CLIENT_GATEWAY_URL_QUERY = gql`
  query GetClientGatewayUrl($input: GetClientGatewayUrlInput!) {
    getClientGatewayUrl(input: $input)
  }
`;
